export default __webpack_public_path__ + "static/media/flowchart.08718c5d.png";